import { SlotGameType1_21 } from '../SlotGameType1_21';

export class LuckyIce4021 extends SlotGameType1_21
{
}
